import { useEffect, useState } from 'react';
import { useUser } from '../../../hooks/useUser';
import { useMessages } from '../../../hooks/useMessages';
import { ActiveMessages } from './ActiveMessagesDisplay';
import { UploadMessage } from '../MessageForms/UploadMessage';
import { ChatsList } from '../../../interfaces/userInterfaces';
import { EditDirectMessage } from '../MessageForms/EditMessage';
import { InitializeChat } from '../MessageForms/InitializeChat';

interface DMProps {
  profile: string;
}

export const DirectMessageUser: React.FC<DMProps> = (profile) => {
  const { user } = useUser();

  const {
    listOfOpenChats,
    activeOpenChat,
    setActiveOpenChat,
    setChatMessages,
    setActiveChatId,
    editingMessage,
  } = useMessages();

  const [existingChat, setExistingChat] = useState<ChatsList[]>();

  useEffect(() => {
    const checkForMessages = listOfOpenChats.filter(
      (chat) =>
        (profile.profile !== user?.username && chat.user_1 === profile.profile) ||
        chat.user_2 === profile.profile
    );

    if (checkForMessages && checkForMessages.length > 0) {
      setExistingChat(checkForMessages);
    }
  }, []);

  useEffect(() => {
    if (existingChat !== undefined && existingChat[0] !== undefined) {
      setActiveOpenChat(existingChat[0]);
      setActiveChatId(existingChat[0].chat_id);
      setChatMessages(existingChat[0].messages);
    }
  }, [existingChat]);

  return (
    <>
      {activeOpenChat.user_1 === profile.profile || activeOpenChat.user_2 === profile.profile ? (
        <div>
          <ActiveMessages />
          {editingMessage ? <EditDirectMessage /> : <UploadMessage />}
        </div>
      ) : (
        <div>
          Send Message To {profile.profile}
          <InitializeChat key={'init-chat-component'} userToMessage={profile.profile} />
        </div>
      )}
    </>
  );
};
